import React from 'react'
import Logo from './logo'
import Button from '@material-ui/core/Button'

export default function Index({ style = {}, ...props }) {
  return (
    <Button
      style={{
        backgroundColor: '#4F5B62',
        borderTopLeftRadius: 150,
        fontWeight: '600',
        color: '#FFF',
        textTransform: 'none',
        minWidth: '30px',
        height: '70px',
        padding: '20px 25px 15px 35px',
        ...style,
      }}
      size="large"
      {...props}
    >
      <Logo style={{ transform: 'scale(1.3)' }} />
    </Button>
  )
}
